export const locale = {
    lang: 'fr',
    data: {
        CREATE_SUB_PROJECT: 'Créer un sous-projet',
        GENERAL: 'Général',
        MEMBERS: 'Membres'
    }
};
